// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1cMhq","title":"Info_title__2DBoq","selects":"Info_selects__9MzoI","requiredAsterisk":"Info_requiredAsterisk__XLgQ0"};